import React, { useEffect, useState } from "react"
import { Button, Form, Modal } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import swal from "sweetalert"
import { useAppDispatch } from "../../app/hooks"
import { markAsException } from "../../store/parcel.store"

const MarkAsExceptionModal = ({
    show,
    handleClose,
    data,
    exceptionReasons
}: {
    show: string
    handleClose: () => void
    data: Record<string, any>
    exceptionReasons: Record<string, any>
}) => {
    const { t } = useTranslation()
    const [loading, setLoading] = useState(false)
    const [showError, setShowError] = useState<boolean>(false)
    const [disableAddParcel, setDisableAddParcel] = useState<boolean>(false)

    const dispatch = useAppDispatch()
    const [parcelDetails, setParcelDetails] = useState({
        status: "",
        id: "",
        details: ""
    })
    const checkAllRequiredFields = () => {
        if (parcelDetails.status && parcelDetails.status !== "") {
            setDisableAddParcel(false)
        } else {
            setDisableAddParcel(true)
        }
    }

    useEffect(() => {
        checkAllRequiredFields()
    }, [parcelDetails.status])

    useEffect(() => {
        setParcelDetails({ ...parcelDetails, id: data.id })
    }, [data.id])

    const addParcelDetail = async () => {
        var purchased: any = await dispatch(markAsException(parcelDetails))
        if (purchased?.payload?.data && purchased?.payload?.data?.status === true) {
            setLoading(false)
            swal({
                title: "",
                text: t("Parcel_Marked_As_Exception"),
                icon: "success"
            }).then(function () {
                handleClose()
            })
        } else {
            swal({
                title: "",
                text: t("Parcel_Not_Marked_As_Exception"),
                icon: "error"
            }).then(function () {
                handleClose()
            })
        }
    }
    const handleCreateParcel = async (e: any) => {
        setLoading(true)
        addParcelDetail()
    }
    return (
        <Modal
            show={show === "markException"}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="lg"
            centered>
            <Modal.Header closeButton>
                <Modal.Title>{t("Mark as Exception")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>{t("Mark_As_Exception_description")}</div>
                <Form noValidate className="form">
                    <Form.Group className="mt-2" controlId="awb">
                        <Form.Label column md="4" sm="2">
                            {t("Mark_as_exception_reason")}
                        </Form.Label>
                        <Form.Select
                            name="status"
                            onChange={(e: any) => {
                                if (e?.target?.value && e?.target?.value !== "") {
                                    setParcelDetails({
                                        ...parcelDetails,
                                        [e.target.name]: JSON.parse(e.target.value)?.id,
                                        details: JSON.parse(e.target.value)?.name
                                    })
                                }
                            }}>
                            <option value="">{t("Select_Exception")}</option>
                            {exceptionReasons?.map((reason: any) => (
                                <option key={reason?.id} value={JSON.stringify(reason)}>
                                    {reason?.name}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    disabled={loading || disableAddParcel}
                    id="btn-primary"
                    className="btn btn-primary"
                    type="submit"
                    onClick={handleCreateParcel}>
                    {" "}
                    {loading ? <div className="spinner-border text-light" role="status"></div> : t("Save")}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default MarkAsExceptionModal
